import { GetStaticPaths, GetStaticProps } from "next";
import { getStringQueryParam } from "src/services/UrlService";
import AffiliateOffersPage, {
  AffiliatePageProps,
  affiliateGetStaticPaths,
  getAffiliateStaticProps,
} from "src/shared/affiliate";

export default AffiliateOffersPage;

export const getStaticPaths: GetStaticPaths = affiliateGetStaticPaths;
export const getStaticProps: GetStaticProps<AffiliatePageProps> = async (context) => {
  return getAffiliateStaticProps(getStringQueryParam(context.params?.state), "sportsbook");
};
